(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ashperoo-image-cards-popup')) {
    customElements.define('ashperoo-image-cards-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.icController) return;
        this.icDialog = this.querySelector('.ic-dialog');
        if (!this.icDialog) return;
        this.icController = new AbortController();
        const signal = this.icController.signal;
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ic-open]');
          if (!trigger || !this.contains(trigger)) return;
          const template = trigger.closest('.ic-card').querySelector('[data-ic-template]');
          if (!template) return;
          const content = this.icDialog.querySelector('[data-ic-modal-body]');
          content.replaceChildren(template.content.cloneNode(true));
          content.querySelector('.ic-modal-title').id = this.icDialog.getAttribute('aria-labelledby');
          this.icTrigger = trigger;
          this.icDialog.showModal();
          this.icOldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }, { signal });
        this.icDialog.querySelector('[data-ic-close]').addEventListener('click', () => this.icDialog.close(), { signal });
        this.icDialog.addEventListener('click', (event) => {
          if (event.target !== this.icDialog) return;
          const rect = this.icDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.icDialog.close();
        }, { signal });
        this.icDialog.addEventListener('close', () => {
          this.icUnlock();
          if (this.icTrigger?.isConnected) this.icTrigger.focus();
        }, { signal });
      }
      icUnlock() {
        if (this.icOldOverflow !== undefined) {
          document.documentElement.style.overflow = this.icOldOverflow;
          this.icOldOverflow = undefined;
        }
      }
      disconnectedCallback() {
        if (this.icDialog?.open) this.icDialog.close();
        this.icUnlock();
        this.icController?.abort();
        this.icController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
